(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Force logo to stay at full size on mobile - prevents shrinking on page load
  if (window.innerWidth <= 990) {
    const preventLogoShrink = () => {
      const logoWrappers = document.querySelectorAll('.header__heading-logo-wrapper');
      const logos = document.querySelectorAll('.header__heading-logo');
      
      logoWrappers.forEach(wrapper => {
        wrapper.style.setProperty('width', '100%', 'important');
        wrapper.style.setProperty('max-width', '100%', 'important');
        wrapper.style.setProperty('transform', 'none', 'important');
        wrapper.style.setProperty('transition', 'none', 'important');
      });
      
      logos.forEach(logo => {
        logo.style.setProperty('transform', 'none', 'important');
        logo.style.setProperty('transition', 'none', 'important');
      });
      
      console.log('Logo shrink prevention applied:', logoWrappers.length, 'wrappers found');
    };
    
    // Run immediately
    preventLogoShrink();
    
    // Run after DOM is fully loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', preventLogoShrink);
    }
    
    // Run repeatedly to override any external scripts
    setTimeout(preventLogoShrink, 100);
    setTimeout(preventLogoShrink, 500);
    setTimeout(preventLogoShrink, 1000);
    setTimeout(preventLogoShrink, 1500);
    setTimeout(preventLogoShrink, 2000);
    setTimeout(preventLogoShrink, 3000);
    
    // Watch for any changes and reapply
    const observer = new MutationObserver(preventLogoShrink);
    setTimeout(() => {
      const header = document.querySelector('.section-header');
      if (header) {
        observer.observe(header, { attributes: true, subtree: true, attributeFilter: ['style', 'class'] });
        console.log('Logo protection observer started');
      }
    }, 100);
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.hasUserScrolled = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Ensure headerBounds is initialized before checking
      if (!this.headerBounds || !this.headerBounds.bottom) return;

      // Mark that user has scrolled (prevents automatic shrinking on page load)
      if (Math.abs(scrollTop - this.currentScrollTop) > 5) {
        this.hasUserScrolled = true;
      }

      // Only apply scrolled-past-header if user has actually scrolled
      if (!this.hasUserScrolled) {
        this.currentScrollTop = scrollTop;
        return;
      }

      // Only apply scrolled-past-header when actually scrolled past the header
      const scrollThreshold = this.headerBounds.bottom;

      // DISABLED: Logo shrinking functionality removed to fix mobile loading issue
      // The scrolled-past-header class is no longer added to prevent logo size changes
      
      if (scrollTop > this.currentScrollTop && scrollTop > scrollThreshold) {
        // this.header.classList.add('scrolled-past-header'); // DISABLED
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > scrollThreshold) {
        // this.header.classList.add('scrolled-past-header'); // DISABLED
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
